export enum ContactWorkflowStepActionEnum {
  AddTag = 'add_tag',
  RemoveTag = 'remove_tag',
  EnrollInCourse = 'enroll_in_course',
  RevokeAccessToCourse = 'revoke_access_to_course',
  EnrollInCourseBundle = 'enroll_in_course_bundle',
  RevokeAccessToCourseBundle = 'revoke_access_to_course_bundle',
  SubscribeToCampaign = 'subscribe_to_campaign',
  UnsubscribeFromCampaign = 'unsubscribe_from_campaign',
  SendEmail = 'send_email',
  SendEmailToSpecificAddress = 'send_email_to_specific_address',
  SendWebhook = 'send_webhook',
  GrantAccessToCommunity = 'grant_access_to_community',
  RevokeAccessToCommunity = 'revoke_access_to_community',
  SendToGoogleSheets = 'send_to_google_sheets',
  AssignPipelineStage = 'assign_pipeline_stage',
  SendSms = 'send_sms',
}
